import { Flex, Text } from "@chakra-ui/react";
import { SavedFile } from "../types/files.types";
import FileIconDefault from "./icons/files/FileIconDefault";
import { ReactNode } from "react";
import FileIconPng from "./icons/files/FileIconPng";
import FileIconPdf from "./icons/files/FileIconPdf";
import { DownloadIcon } from "@chakra-ui/icons";
import { fetchFileContent } from "../mutations/file.mutations";
import { useMutation } from "react-query";

function Document({ file }: { file: SavedFile }) {
  const DocumentIcon = () => {
    const defaultIcon = (
      <FileIconDefault w="40px" h="40px" color="brand.700"></FileIconDefault>
    );
    // Find extension
    const fileNameToken = file.fileName.split(".");
    if (fileNameToken.length <= 1) {
      return defaultIcon;
    }
    const extension = fileNameToken[fileNameToken.length - 1];
    // Map extension to icon
    const extToIcon = new Map<string, ReactNode>([
      ["png", <FileIconPng w="40px" h="40px" color="brand.700"></FileIconPng>],
      ["pdf", <FileIconPdf w="40px" h="40px" color="brand.700"></FileIconPdf>],
    ]);
    // Try to find related icon
    if (extToIcon.has(extension)) {
      return extToIcon.get(extension);
    }
    // Default Icon
    return defaultIcon;
  };

  const { mutate: downloadFileContent } = useMutation(fetchFileContent, {
    onSuccess: (content: string) => {
        const blob = new Blob([content])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = file.fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
  })
  const handleDownload = () => {
    downloadFileContent(file.id)
  }

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Flex>
        <DocumentIcon></DocumentIcon>
        <Text ml={4} lineHeight="40px" fontSize="14px" fontWeight="600">
          {file.fileName}
        </Text>
      </Flex>
      <DownloadIcon w="21px" h="21px" onClick={handleDownload}></DownloadIcon>
    </Flex>
  );
}

export default Document;
